<template>
    <el-dialog class="middleDialog" :visible.sync="visible" :close-on-click-modal="false" top="auto" width="95vw"
        @close="closeClick" :modal-append-to-body="false" :append-to-body="true">
        <div class="card">
            <div class="attachmentMBox">
                <div class="topBox">
                    <div class="userBox">
                        <div class="left">
                            <div class="avatar-container">
                                <img :src="getUserAvatar()" alt="" srcset="" class="user-avatar">
                                <div class="online-indicator"></div>
                            </div>
                            <div class="user-info">
                                <span class="name">{{ getUserName() || 'XXX' }}</span>
                                <span class="status">在线</span>
                            </div>
                        </div>
                        <div class="right">
                            <div class="title-container">
                                <i class="el-icon-folder-opened"></i>
                                <span>媒体库</span>
                            </div>
                        </div>
                    </div>

                    <!-- 媒体类型切换 -->
                    <div class="bigNav">
                        <div class="left">
                            <el-tabs v-model="activeMediaType" class="compact-tabs">
                                <el-tab-pane name="photo">
                                    <span slot="label">
                                        <i class="el-icon-camera-solid"></i>
                                        <span>照片</span>
                                    </span>
                                </el-tab-pane>
                                <el-tab-pane name="video"
                                    v-if="!photoOnly && currentMessageType !== 'newsFeed' && currentMessageType !== 'masSending'">
                                    <span slot="label">
                                        <i class="el-icon-video-camera-solid"></i>
                                        <span>视频</span>
                                    </span>
                                </el-tab-pane>
                                <el-tab-pane name="audio"
                                    v-if="!photoOnly && currentMessageType === 'chat' && !hideAudio">
                                    <span slot="label">
                                        <i class="el-icon-message-solid"></i>
                                        <span>音频</span>
                                    </span>
                                </el-tab-pane>
                            </el-tabs>
                        </div>
                        <div class="right">
                            <div class="action-buttons">
                                <div class="commonDiv upload-btn" @click="upFileFun" v-if="!photoOnly">
                                    <i class="el-icon-upload"></i>
                                    <span>上传</span>
                                </div>
                                <div v-if="!editMode" class="commonDiv send-btn"
                                    :class="{ active: selectedItems.length > 0 }" @click="sendSelectedItems">
                                    <i class="el-icon-s-promotion"></i>
                                    <span>发送({{ selectedItems.length }})</span>
                                </div>
                                <div v-if="!editMode && !photoOnly" class="commonDiv edit-btn" @click="goToManagement">
                                    <i class="el-icon-setting"></i>
                                    <span>管理</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- 媒体内容区域 -->
                <div class="bottomBox">
                    <!-- 照片组件 -->
                    <PhotoLibrary v-if="activeMediaType === 'photo'" ref="photoLibrary" :chat-user-info="chatUserInfo"
                        :edit-mode="editMode" :approved-only="approvedOnly" :current-message-type="currentMessageType"
                        :show-approved-only="currentMessageType === 'chat'"
                        :show-email-tags="showEmailTags || currentMessageType === 'email'"
                        :show-news-feed-only="currentMessageType === 'newsFeed'"
                        :show-mas-sending-only="currentMessageType === 'masSending'"
                        :enable-forbidden-tags="enableForbiddenTags || currentMessageType === 'email' || currentMessageType === 'postView'" @item-selected="handleItemSelected"
                        @item-deselected="handleItemDeselected" />
                    <!-- 调试信息 -->
                    <div v-if="false" style="display: none;">
                        editMode: {{ editMode }},
                        currentMessageType: {{ currentMessageType }},
                        showApprovedOnly: {{ currentMessageType === 'chat' }},
                        showEmailTags: {{ currentMessageType === 'email' }},
                        showNewsFeedOnly: {{ currentMessageType === 'newsFeed' }}
                    </div>

                    <!-- 视频组件 -->
                    <VideoLibrary v-if="activeMediaType === 'video' && !photoOnly && currentMessageType !== 'newsFeed'"
                        ref="videoLibrary" :chat-user-info="chatUserInfo" :edit-mode="editMode"
                        :approved-only="approvedOnly" :current-message-type="currentMessageType"
                        :show-approved-only="currentMessageType === 'chat'"
                        :show-email-tags="currentMessageType === 'email' || currentMessageType === 'masSending'"
                        :enable-forbidden-tags="currentMessageType === 'email' || currentMessageType === 'postView'" @item-selected="handleItemSelected"
                        @item-deselected="handleItemDeselected" />

                    <!-- 音频组件 -->
                    <AudioLibrary
                        v-if="activeMediaType === 'audio' && !photoOnly && currentMessageType === 'chat' && !hideAudio"
                        ref="audioLibrary" :chat-user-info="chatUserInfo" :edit-mode="editMode"
                        :approved-only="approvedOnly" :current-message-type="currentMessageType"
                        :show-approved-only="currentMessageType === 'chat'" @item-selected="handleItemSelected"
                        @item-deselected="handleItemDeselected" />
                </div>

                <!-- 上传弹窗 -->
                <el-dialog class="uploadDialog" :visible.sync="uploadShow" width="50%" :before-close="uploadClose"
                    :modal="false">
                    <uploadMark ref="uploadRef" :upload-show="uploadShow" :platform-type="platformType"
                        :platform-user-id="platformUserId" :user-id="userId" :initial-file-type="currentFileType"
                        @upload-close="uploadClose" @upload-complete="uploadComplete" />
                </el-dialog>
            </div>
        </div>
    </el-dialog>
</template>

<script>
import PhotoLibrary from './mediaLibrary/PhotoLibrary.vue'
import VideoLibrary from './mediaLibrary/VideoLibrary.vue'
import AudioLibrary from './mediaLibrary/AudioLibrary.vue'
import uploadMark from './uploadMark.vue'

export default {
    name: 'Attachment',
    components: {
        PhotoLibrary,
        VideoLibrary,
        AudioLibrary,
        uploadMark
    },
    props: {
        chatUserInfo: {
            type: Object,
            default: () => ({})
        },
        photoOnly: {
            type: Boolean,
            default: false
        },
        approvedOnly: {
            type: Boolean,
            default: false
        },
        currentMessageType: {
            type: String,
            default: 'chat', // chat, newsFeed, email，masSending
        },
        hideAudio: {
            type: Boolean,
            default: false
        },
        showEmailTags: {
            type: Boolean,
            default: false
        },
        enableForbiddenTags: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            visible: false,
            activeMediaType: this.getDefaultMediaType(),
            uploadShow: false,
            selectedItems: [],
            editMode: false,
            platformType: 'talkytimes',
            platformUserId: this.chatUserInfo.platformUserId,
            userId: this.chatUserInfo.userId
        }
    },
    computed: {
        currentFileType() {
            switch (this.activeMediaType) {
                case 'photo': return '图片'
                case 'video': return '视频'
                case 'audio': return '音频'
                default: return '图片'
            }
        }
    },
    watch: {
        visible: {
            handler(newVal) {
                if (newVal) {
                    // 当对话框打开时，确保数据是最新的
                    this.$nextTick(() => {
                        this.refreshAllLibraries();
                    });
                } else {
                    // 当对话框关闭时，清理状态
                    this.cleanupState();
                }
            },
            immediate: true
        },
        activeMediaType: {
            handler(newVal) {
                if (!newVal) return;
                // 如果photoOnly为true且尝试切换到非照片tab，则阻止
                if (this.photoOnly && newVal !== 'photo') {
                    this.activeMediaType = 'photo';
                    return;
                }
                // 如果currentMessageType不是chat且尝试切换到音频tab，则阻止
                if (this.currentMessageType !== 'chat' && newVal === 'audio') {
                    this.activeMediaType = 'photo';
                    return;
                }
                // 如果currentMessageType为newsFeed且尝试切换到非照片tab，则阻止
                if (this.currentMessageType === 'newsFeed' && newVal !== 'photo') {
                    this.activeMediaType = 'photo';
                    return;
                }
                // 如果currentMessageType为masSending且尝试切换到非照片tab，则阻止
                if (this.currentMessageType === 'masSending' && newVal !== 'photo') {
                    this.activeMediaType = 'photo';
                    return;
                }
                // 如果hideAudio为true且尝试切换到音频tab，则阻止
                if (this.hideAudio && newVal === 'audio') {
                    this.activeMediaType = 'photo';
                    return;
                }
                // 清空选中项
                this.selectedItems = [];
            },
            immediate: true
        },
        currentMessageType: {
            handler(newVal) {
                // 当消息类型改变时，重新设置默认的媒体类型
                this.activeMediaType = this.getDefaultMediaType();
                // 清空选中项
                this.selectedItems = [];

                // 如果是email类型，子组件会自动加载禁止标签
                if (newVal === 'email') {
                    // 子组件会自动处理
                } else {
                    // 如果不是email类型，子组件会自动处理
                }
            },
            immediate: true
        },
        chatUserInfo: {
            handler(newVal, oldVal) {
                // 当聊天用户信息变化时，刷新媒体库数据
                if (newVal && oldVal && newVal.userId !== oldVal.userId) {
                    this.refreshAllLibraries();

                    // 如果是email类型，子组件会自动加载禁止标签
                    if (this.currentMessageType === 'email') {
                        // 子组件会自动处理
                    }
                }
            },
            deep: true
        }
    },
    methods: {
        getUserName() {
            // 获取本地存储的 activeUser
            console.log('getUserName - chatUserInfo.userDetail:', this.chatUserInfo);
            if (this.chatUserInfo.userDetail && this.chatUserInfo.platformUserId !== 'default') {
                return this.chatUserInfo.userDetail.name;
            } else {
                console.log('getUserName - chatUserInfo.userDetail is null');
                const activeUserStr = localStorage.getItem('activeUser');
                if (activeUserStr) {
                    try {
                        const activeUser = JSON.parse(activeUserStr);
                        if (activeUser && activeUser.name) {
                            return activeUser.name;
                        }
                    } catch (error) {
                        console.error('解析 activeUser 失败:', error);
                    }
                }
            }
            return 'XXX';
        },
        getUserAvatar() {
            console.log('getUserAvatar - chatUserInfo.userDetail:', this.chatUserInfo);
            if (this.chatUserInfo.userDetail && this.chatUserInfo.platformUserId !== 'default') {
                return this.chatUserInfo.userDetail.avatar_large || require('../../../../../assets/profile.png');
            } else {
                console.log('getUserAvatar - chatUserInfo.userDetail is null');
                const activeUserStr = localStorage.getItem('activeUser');
                if (activeUserStr) {
                    try {
                        const activeUser = JSON.parse(activeUserStr);
                        if (activeUser) {
                            return activeUser.personalAvatar_xl || require('../../../../../assets/profile.png');
                        }
                    } catch (error) {
                        console.error('解析 activeUser 失败:', error);
                    }
                }
            }
            return require('../../../../../assets/profile.png');
        },
        getDefaultMediaType() {
            // 根据不同的消息类型返回默认的媒体类型
            if (this.photoOnly || this.currentMessageType === 'email' || this.currentMessageType === 'newsFeed' || this.currentMessageType === 'masSending' || this.hideAudio) {
                return 'photo';
            }
            return 'photo'; // 默认选择照片
        },

        init() {
            this.visible = true;
            this.$emit('visible-change', true);
            this.resetParams();

            // 如果是email类型，子组件会自动获取禁止标签
            if (this.currentMessageType === 'email') {
                // 子组件会自动处理
            }
        },

        resetParams() {
            // 根据不同的消息类型设置默认的媒体类型
            this.activeMediaType = this.getDefaultMediaType();
            this.selectedItems = [];
            this.uploadShow = false;
        },

        handleItemSelected(item) {
            this.selectedItems.push(item);
        },

        handleItemDeselected(item) {
            // 使用更通用的查找方式，因为不同媒体类型可能有不同的ID字段
            const index = this.selectedItems.findIndex(i => {
                // 照片使用 idPhoto
                if (i.idPhoto && item.idPhoto) {
                    return i.idPhoto === item.idPhoto;
                }
                // 视频使用 idVideo
                if (i.idVideo && item.idVideo) {
                    return i.idVideo === item.idVideo;
                }
                // 音频使用 id
                if (i.id && item.id) {
                    return i.id === item.id;
                }
                // 通用ID
                if (i.id && item.id) {
                    return i.id === item.id;
                }
                return false;
            });
            if (index !== -1) {
                this.selectedItems.splice(index, 1);
            }
        },

        sendSelectedItems() {
            if (this.selectedItems.length === 0) return;

            let type = '';
            switch (this.activeMediaType) {
                case 'photo':
                    type = 'image';
                    break;
                case 'video':
                    type = 'video';
                    break;
                case 'audio':
                    type = 'audio';
                    break;
            }
            // return
            if (this.currentMessageType === 'chat') {
                // talkytimes消息路径的逻辑
                if (type === 'image') {
                    for (let i = 0; i < this.selectedItems.length; i += 6) {
                        this.$emit('send-sonMediaMessage', {
                            bTypeVal: type,
                            dataMsgList: this.selectedItems.slice(i, i + 6),
                            isLast: i + 6 >= this.selectedItems.length
                        });
                    }
                } else {
                    for (let i = 0; i < this.selectedItems.length; i++) {
                        this.$emit('send-sonMediaMessage', {
                            bTypeVal: type,
                            dataMsgList: [this.selectedItems[i]],
                            isLast: i === this.selectedItems.length - 1
                        });
                    }
                }
            } else if (this.currentMessageType === 'newsFeed') {
                // 新闻动态的逻辑
                this.$emit('get-sonMediaMessage', { dataMsgList: this.selectedItems });
            } else if (this.currentMessageType === 'email' || this.currentMessageType === 'masSending' || this.currentMessageType === 'postView') {
                // 邮件、masSending和postView的逻辑
                this.$emit('send-sonMediaMessage', {
                    bTypeVal: type,
                    dataMsgList: this.selectedItems
                });
            }

            this.selectedItems = [];
            this.closeClick();
        },

        deleteSelectedItems() {
            if (this.selectedItems.length === 0) return;

            // 调用当前激活的媒体库组件的删除方法
            const currentLibrary = this.$refs[`${this.activeMediaType}Library`];
            if (currentLibrary && currentLibrary.deleteItems) {
                currentLibrary.deleteItems(this.selectedItems);
            }

            this.selectedItems = [];
        },

        goToManagement() {
            // 跳转到媒体库管理页面
            this.$router.push({
                path: '/talkytimes/mediaLibrary',
                query: {
                    mediaType: this.activeMediaType,
                    from: 'attachment'
                }
            });
            // 关闭当前弹窗
            this.closeClick();
        },


        upFileFun() {
            this.uploadShow = true;
        },

        uploadClose(v) {
            this.uploadShow = false;
            if (v && v.son) {
                this.refreshCurrentLibrary();
            }
        },

        uploadComplete() {
            this.refreshCurrentLibrary();
        },

        refreshCurrentLibrary() {
            const currentLibrary = this.$refs[`${this.activeMediaType}Library`];
            if (currentLibrary && currentLibrary.refresh) {
                currentLibrary.refresh();
            }
        },

        refreshAllLibraries() {
            const photoLibrary = this.$refs.photoLibrary;
            const videoLibrary = this.$refs.videoLibrary;
            const audioLibrary = this.$refs.audioLibrary;

            if (photoLibrary && photoLibrary.refresh) {
                photoLibrary.refresh();
            }
            if (videoLibrary && videoLibrary.refresh) {
                videoLibrary.refresh();
            }
            if (audioLibrary && audioLibrary.refresh && !this.hideAudio) {
                audioLibrary.refresh();
            }
        },

        closeClick() {
            this.visible = false;
            this.$emit('visible-change', false);
            this.selectedItems = [];
        },

        cleanupState() {
            // 彻底清理所有状态和数据
            this.selectedItems = [];
            this.uploadShow = false;

            // 重置媒体类型到默认状态
            this.activeMediaType = this.getDefaultMediaType();

            // 清理子组件状态（如果有的话）
            this.$nextTick(() => {
                this.cleanupChildComponents();
            });
        },

        cleanupChildComponents() {
            // 清理照片库组件状态
            if (this.$refs.photoLibrary && this.$refs.photoLibrary.cleanup) {
                this.$refs.photoLibrary.cleanup();
            }

            // 清理视频库组件状态
            if (this.$refs.videoLibrary && this.$refs.videoLibrary.cleanup) {
                this.$refs.videoLibrary.cleanup();
            }

            // 清理音频库组件状态
            if (this.$refs.audioLibrary && this.$refs.audioLibrary.cleanup) {
                this.$refs.audioLibrary.cleanup();
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.card {
    height: 100%;
    font-size: 12px; // 设置最小字体大小
}

.attachmentMBox {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    padding: 4px; // 从8px减少到4px
    background-color: #fff;
    display: flex;
    flex-direction: column;
    border-radius: 6px; // 从8px减少到6px
    font-size: 12px; // 设置最小字体大小

    .topBox {
        display: flex;
        flex-direction: column;
        width: 100%;

        .userBox {
            display: flex;
            align-items: center;
            margin-bottom: 8px; // 添加底部间距

            .left {
                padding: 4px 6px; // 从6px 8px减少到4px 6px
                background-color: #F7F9FA;
                border-radius: 6px; // 从8px减少到6px
                display: flex;
                align-items: center;

                .avatar-container {
                    position: relative;
                    margin-right: 8px; // 调整头像和信息之间的间距

                    .user-avatar {
                        width: 44px;
                        height: 44px;
                        border-radius: 50%;
                        object-fit: cover;
                    }

                    .online-indicator {
                        position: absolute;
                        bottom: 0;
                        right: 0;
                        width: 12px;
                        height: 12px;
                        background-color: #4CAF50;
                        border-radius: 50%;
                        border: 2px solid #fff;
                    }
                }

                .user-info {
                    display: flex;
                    flex-direction: column;

                    .name {
                        font-weight: 500;
                        font-size: 12px; // 改为最小字体大小
                        color: #333333;
                        margin-bottom: 2px; // 调整名字和状态之间的间距
                    }

                    .status {
                        font-size: 10px; // 更小的字体
                        color: #999999;
                    }
                }
            }

            .right {
                font-weight: 500;
                font-size: 12px; // 改为最小字体大小
                color: #333333;
                margin-left: 20px; // 从40px减少到20px

                .title-container {
                    display: flex;
                    align-items: center;

                    i {
                        margin-right: 4px;
                    }
                }
            }
        }

        .bigNav {
            display: flex;
            width: 100%;
            align-items: flex-start;
            justify-content: space-between;
            // margin-bottom: 8px; // 添加底部间距
            height: 50px;

            .left {
                .compact-tabs {
                    .el-tabs__item {
                        padding: 8px 12px !important; // 减少标签页的padding
                        font-size: 12px !important; // 设置最小字体大小
                    }

                    .el-tab-pane {
                        font-size: 12px !important;
                    }
                }
            }

            .right {
                display: flex;
                justify-content: space-between;
                align-items: center;

                .action-buttons {
                    display: flex;

                    .commonDiv {
                        padding: 8px 16px; // 从12px 24px减少到8px 16px
                        margin-left: 4px; // 从8px减少到4px
                        background: #F7F9FA;
                        border-radius: 6px; // 从8px减少到6px
                        cursor: pointer;
                        font-size: 12px; // 设置最小字体大小
                        display: flex;
                        align-items: center;
                        justify-content: center;

                        i {
                            margin-right: 4px;
                        }

                        &:hover {
                            background: #E4F3FF;
                        }
                    }

                    .commonDiv.active {
                        background: #E4F3FF;
                        color: #2499FF;
                    }
                }
            }
        }
    }

    .bottomBox {
        height: 0;
        flex: 1;
        display: flex;
        flex-direction: column;
        font-size: 12px; // 设置最小字体大小
        padding-top: 4px; // 添加顶部间距
    }
}

// 对话框居中
::v-deep .middleDialog.el-dialog__wrapper {
    top: 3vh; // 从5vh减少到3vh
    z-index: 10001 !important;

    .el-dialog {
        z-index: 10001 !important;
        font-size: 12px; // 设置最小字体大小

        .el-dialog__body {
            height: calc(94vh - 5px); // 从90vh增加到94vh
            box-sizing: border-box;
            font-size: 12px; // 设置最小字体大小
            // padding: 8px; // 减少对话框内容区域的padding
        }
    }
}

.uploadDialog .el-dialog {
    top: 3vh !important; // 从5vh减少到3vh
    margin-top: 0 !important;
    font-size: 12px; // 设置最小字体大小
}

// 全局字体大小设置
::v-deep * {
    font-size: 12px !important;
}

// 确保所有子组件也使用最小字体
::v-deep .el-tabs__item {
    font-size: 12px !important;
    padding: 8px 12px !important; // 减少标签页的padding
}

::v-deep .el-tab-pane {
    font-size: 12px !important;
}

// 调整Element UI组件的间距
::v-deep .el-tabs__nav-wrap {
    padding: 0 4px; // 减少标签导航的padding
}

::v-deep .el-tabs__content {
    padding: 8px 0; // 减少标签内容的padding
}

// 调整对话框标题栏的间距
::v-deep .el-dialog__header {
    padding: 12px 16px; // 减少标题栏的padding
}

::v-deep .el-dialog__body {
    padding: 8px 16px; // 减少对话框主体的padding
}

// 调整按钮组之间的间距
::v-deep .el-button+.el-button {
    margin-left: 4px; // 减少按钮之间的间距
}

// 调整表单元素的间距
::v-deep .el-form-item {
    margin-bottom: 8px; // 减少表单项之间的间距
}

::v-deep .el-input__inner {
    padding: 6px 8px; // 减少输入框的内边距
}

// 调整卡片组件的间距
::v-deep .el-card {
    margin-bottom: 8px; // 减少卡片之间的间距

    .el-card__body {
        padding: 12px; // 减少卡片内容的padding
    }
}

// 按钮特定样式
.upload-btn {
    background: #409eff !important;
    color: white !important;
    border: 1px solid #409eff !important;

    &:hover {
        background: #337ecc !important;
        border-color: #337ecc !important;
    }
}

.send-btn {
    background: #67c23a !important;
    color: white !important;
    border: 1px solid #67c23a !important;

    &:hover {
        background: #5daf34 !important;
        border-color: #5daf34 !important;
    }

    &.active {
        background: #409eff !important;
        border-color: #409eff !important;
    }
}

.edit-btn {
    background: #e6a23c !important;
    color: white !important;
    border: 1px solid #e6a23c !important;

    &:hover {
        background: #cf9236 !important;
        border-color: #cf9236 !important;
    }
}

.delete-btn {
    background: #f56c6c !important;
    color: white !important;
    border: 1px solid #f56c6c !important;

    &:hover {
        background: #dd6161 !important;
        border-color: #dd6161 !important;
    }
}

.cancel-btn {
    background: #909399 !important;
    color: white !important;
    border: 1px solid #909399 !important;

    &:hover {
        background: #82848a !important;
        border-color: #82848a !important;
    }
}
</style>